<cfp-side-panel [title]="'tags.manage' | cfpTranslate" (closeClicked)="close()" [dataTest]="'tagsBuilding'">
  <ng-container body>
    <cfp-tags-toolbar
      [portfolioId]="portfolioId"
      [searchText]="searchText()"
      (searchTextChange)="search($event)"
      (fetchTags)="fetchTags()"
    />

    @if (tags()?.length > 0) {
      <form [formGroup]="form">
        <fieldset>
          <legend>{{ 'tags' | cfpTranslate }}</legend>
          <div class="row cfp-filter-group-block" formArrayName="tags">
            @for (tag of tags(); track tag.tagId) {
              @if (shouldShowTag(tag)) {
                <div class="col-12 col-sm-6 cfp-filter-group-row">
                  <cfp-input-checkbox
                    [id]="'tag_' + tag.tagId"
                    [title]="tag.tag"
                    [dataTest]="tag.tag"
                    [formControl]="getTagFormControl($index)"
                    [label]="tag.tag"
                  >
                  </cfp-input-checkbox>
                </div>
              }
            }
          </div>
        </fieldset>
      </form>
    } @else {
      <div class="text-center p-3">
        <p>{{ 'No tags available' | cfpTranslate }}</p>
      </div>
    }
  </ng-container>

  <ng-container footer>
    <cfp-button (click)="saveAndClose()">Save and Close </cfp-button>
  </ng-container>
</cfp-side-panel>
